import React, { Component } from 'react';
import { getFormattedDate } from '../../../../../helpers/FormatDate';
import {
   TimeframeBorder,
   TimeframeDisplayCharting,
   TimeframeDisplayDate,
   TimeframeDisplayDateData,
   TimeframeDisplayHeader,
   TimeframeDisplayRow
} from './TimeframeDisplay.styled';

export interface ITimeframeDisplay {
   headers: string[];
   open: boolean;
   period: number;
   windowSize;
}

export default class TimeframeDisplay extends Component<ITimeframeDisplay, {}> {
   public render() {
      const { headers, open, period, windowSize } = this.props;
      const timeFrames = headers
         ? headers.map((header, i) => {
              return (
                 <TimeframeDisplayDate key={i}>
                    {i === 0 ? <TimeframeBorder pos={'left'} /> : null}
                    <TimeframeDisplayDateData>{getFormattedDate(header, period)}</TimeframeDisplayDateData>
                    <TimeframeBorder />
                 </TimeframeDisplayDate>
              );
           })
         : [];
      const formattedTimeframeAnalytic = open ? 'Close' : 'Open';

      const responsiveTimeFrames = () => {
         // if (windowSize.isExtraSmall) {
         //    return timeFrames.slice(0, 2);
         // }
         // if (windowSize.isSmall) {
         //    return timeFrames.slice(0, 3);
         // } else {
         return timeFrames;
         //}
      };

      return (
         <TimeframeDisplayRow>
            <TimeframeDisplayHeader colSpan={3} data-analytics={`Timeframe-${formattedTimeframeAnalytic}`} />
            {responsiveTimeFrames()}
            <TimeframeDisplayCharting />
         </TimeframeDisplayRow>
      );
   }
}
